module.exports = __webpack_public_path__ + "static/media/231.0201ebfb.webp";